import { render, staticRenderFns } from "./ExchangeInput.vue?vue&type=template&id=2c489f98&scoped=true&"
import script from "./ExchangeInput.vue?vue&type=script&lang=js&"
export * from "./ExchangeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c489f98",
  null
  
)

export default component.exports